import React from "react";
import { useAuth } from "../../contexts/AuthContext";

import Menu from "../UI/Menu/Menu";
import MenuItem from "../UI/Menu/MenuItem";

export default function Navigation() {
  const { currentUser, isAdmin } = useAuth();

  //icons from img/icons.svg
  const links = [
    { link: "/users", name: "Люди", icon: "leaderboard" },
    { link: "/profile", name: "Мой профиль", icon: "home" },
    { link: "/contracts", name: "Задания", icon: "tasks" },
  ];

  //tmp for admin
  if (currentUser && isAdmin) {
    links.push(
      { link: "/admin", name: "Админ", icon: "star" }
    );
  }

  return (
    <>
      {currentUser && (
        <Menu>
          {links.map((item, i) => (
            <MenuItem
              key={i}
              title={item.name}
              to={item.link}
              activeClassName="Menu__item_state_active"
              icon={item.icon}
            />
          ))}
        </Menu>
      )}
    </>
  );
}
